import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Lenis from 'lenis';

export default function SmoothScroll({ children }) {
  const { pathname } = useLocation();
  const lenisRef = useRef(null);

  useEffect(() => {
    let lenis;
    let rafId;

    if (pathname !== '/isho' && pathname !== '/login') {
      lenis = new Lenis({
        duration: 2.0, // Heavier, slower settlement
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        direction: 'vertical',
        gestureDirection: 'vertical',
        smooth: true,
        mouseMultiplier: 0.8, // Reduced sensitivity
        smoothTouch: false,
        touchMultiplier: 1.5,
      });
      
      lenisRef.current = lenis;

      function raf(time) {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
      }

      rafId = requestAnimationFrame(raf);
      lenis.scrollTo(0, { immediate: true });
    } else {
      lenisRef.current = null;
      window.scrollTo(0, 0);
    }

    return () => {
      if (lenis) {
        lenis.destroy();
        cancelAnimationFrame(rafId);
      }
    };
  }, [pathname]);

  return children;
}
